<div (click)="createOblibenyUkon()" class="button" *ngIf="canEdit()">
  <svg [attr.width]="size" [attr.height]="size" viewBox="0 0 24 24" class="star-image">
    <path
      [attr.fill]="ukon?.oblibeny ? 'gold' : 'none'"
      stroke="gold"
      d="M12 .587l3.668 7.568L24 9.423l-6 5.845L19.335 24 12 19.897 4.665 24 6 15.268 0 9.423l8.332-1.268z"
    />
  </svg>
</div>
